<template>
  <div class="sf-modal-content sf-pad-3 sf-align-c">
    <p class="sf-c-text sf-font-light sf-below-3 sf-font-xs">
      {{ documentFileName }}
    </p>

    <img
      :alt="status"
      class="sf-below-3"
      :src="$imagesRequire(`virus_scan_status/${status}.svg`)"
    />
    <div class="sf-below-3">
      <div
        class="sf-font-l sf-c-text-dark sf-font-medium sf-below-1 sf-pad-h-2"
      >
        {{ I18n.t(`permanent_document.virus_scanning.title.${status}`) }}
      </div>
      <div v-if="status === 'failed' || status === 'unsafe'">
        <div class="sf-font-light sf-c-text-dark">
          {{ I18n.t(`permanent_document.virus_scanning.text.${status}`) }}
        </div>
      </div>
    </div>

    <div class="sf-below-3">
      <div class="sf-level sf-level-center sf-below-1 sf-font-xs">
        <div class="sf-c-text sf-font-light">
          {{ documentFileName }}
          <span>&bull;</span>
          {{ documentFileSize }}
        </div>
      </div>

      <div v-if="status !== 'safe'" class="sf-align-c sf-c-text sf-font-light">
        {{ I18n.t('permanent_document.virus_scanning.uploaded') }}
        <span class="sf-c-text-darker sf-font-normal">
          {{ documentCreatedAt }}
        </span>
        <span v-if="documentCreatedBy">
          {{ I18n.t('permanent_document.show.by') }}
          <span class="sf-c-text-darker sf-font-normal">
            {{ documentCreatedBy }}</span
          >
        </span>
      </div>
    </div>

    <div
      v-if="status === 'not_performed' || status === 'in_progress'"
      class="sf-level sf-level-center sf-below-3"
    >
      <div class="sf-spinner sf-spinner-l sf-spinner-primary" />
    </div>

    <a
      v-if="status === 'safe'"
      :href="documentUrl"
      :download="documentFileName"
      class="sf-btn sf-btn-primary"
    >
      {{ I18n.t('tooltips.documents.download') }}
    </a>

    <a v-else class="sf-btn" data-dismiss="sf-modal" href="#">
      {{ I18n.t('common.close') }}
    </a>
  </div>
</template>

<script>
import Polling from '../../../utils/polling'

export default {
  name: 'VirusScanning',
  props: [
    'documentId',
    'documentFileName',
    'documentFileSize',
    'documentCreatedAt',
    'documentCreatedBy',
    'documentUrl',
    'channelName',
    'lastMessageBusId',
    'initialStatus',
  ],

  data() {
    return {
      status: this.initialStatus,
    }
  },

  mounted() {
    this.handleResponse = this.handleResponse.bind(this)

    this.polling = new Polling(
      this.channelName,
      parseInt(this.lastMessageBusId),
      this.handleResponse
    )

    this.polling.subscribe()
  },

  methods: {
    handleResponse(args) {
      if (args.document_id === parseInt(this.documentId)) {
        this.status = args.status
        this.polling.unsubscribe()
      }
    },
  },
}
</script>
